import { request } from '../request'

//获取列表
export function getCostList(data) {
  return request({
    url: '/award/wjpaybusinessrecord/page',
    method: 'get',
    params: data
  })
}

// 传播奖励上部信息
export function getSpreadHList(data) {
  return request({
    url: '/award/wjpayaccountrecord/headData',
    method: 'get',
    params: data
  })
}
// 答题奖励上部信息
export function getAnswerHList(data) {
  return request({
    url: '/award/wjpaybusinessrecord/headData',
    method: 'get',
    params: data
  })
}
// 面访按答题查询上部信息
export function getOfflineAnswerHList(data) {
  return request({
    url: 'award/wjpaybusinessrecord/getAnswerMoneySummary',
    method: 'get',
    params: data
  })
}
// 面访按访问者查询上部信息
export function getOfflineWorkerHList(data) {
  return request({
    url: 'award/wjpaybusinessrecord/getWorkerMoneySummary',
    method: 'get',
    params: data
  })
}
// 获取交易流水
export function getWaterList(data) {
  return request({
    url: '/award/wjpayaccountrecord/page',
    method: 'get',
    params: data
  })
}

// 导出答卷数据
export function dcExlList(params) {
  return request({
    url: '/answer/answer/getanswer/' + params,
    method: 'GET'
  })
}

// 成本统计 导出 20200622
export function exportExcel(params) {
  return request({
    url: '/award/wjpaybusinessrecord/export',
    method: 'GET',
    responseType: 'blob',
    params
  })
}

// 获取面访任务的问卷结算信息
export function getOfflineList(params, offlineType) {
  // 获取面访任务的问卷结算信息
  let url = '/award/wjpaybusinessrecord/getAnswerMoneyRecord'
  if (offlineType == 'visitor') {
    // 获取面访任务的问卷结算信息
    url = '/award/wjpaybusinessrecord/getWorkerMoneyRecord'
  }
  return request({
    url,
    method: 'GET',
    params
  })
}

// 新增或编辑答卷补款扣款 / 批量
export function supplementAnswerItemMoney(data, bach) {
  let url = '/award/wjpaybusinessrecord/supplementAnswerItemMoney'
  if (bach == 'bach') {
    // 批量
    url = '/award/wjpaybusinessrecord/supplementAnswerItemMoneyBatch'
  }
  return request({
    url,
    method: 'POST',
    data,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 新增或修改调查员补款扣款 / 批量
export function supplementWorkerMoney(data, bach) {
  let url = '/award/wjpaybusinessrecord/supplementWorkerMoney'
  if (bach == 'bach') {
    // 批量
    url = '/award/wjpaybusinessrecord/supplementWorkerMoneyBatch'
  }
  return request({
    url,
    method: 'POST',
    data,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 导出财务报销凭证PDF
export function exportPDF(params) {
  return request({
    url: '/award/wjpaybusinessrecord/exportPDF',
    method: 'GET',
    params
  })
}

// 导出费用明细Excel
export function exportDetailExcel(params) {
  return request({
    url: '/award/wjpaybusinessrecord/exportDetailExcel',
    method: 'GET',
    params
  })
}
